module.exports = __webpack_public_path__ + "assets/img/11_668_big.cc5bd552.jpg";